import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import getMatchInfoByIdThunk from '../store/matchDetail/actions/getMatchInfoById';
import matchDetailCleanup from '../store/matchDetail/actions/cleanup';
import {MatchInfo} from '../utils/types';
import {AppState} from '../store/types';

/**
 * Return type of the useMatchInfo hook
 */
type UseMatchInfoResult = [
  {loading: boolean, data?: MatchInfo, error?: string | boolean},
  {getMatchInfoById: typeof getMatchInfoByIdThunk, cleanup: () => void},
]

/**
 * Selects the 'detail' state and sum it up into a referring object
 */
const matchInfoSelector = (state: AppState) => ({
  loading: state.detail.isFetching,
  data: state.detail.data,
  error: state.detail.didInvalidate ? state.detail.error : false,
});

/**
 * Wraps up the business logic of selecting the 'detail' state.
 */
const useMatchInfo = (): UseMatchInfoResult => {
  const dispatch = useDispatch();
  const state = useSelector(matchInfoSelector);

  const getMatchInfoById = useCallback((id: string) => dispatch(getMatchInfoByIdThunk(id)), [dispatch]);
  const cleanup = useCallback(() => {
    dispatch(matchDetailCleanup());
  }, [dispatch]);

  return [state, {getMatchInfoById, cleanup}];
};


export default useMatchInfo;
